import { render, staticRenderFns } from "./CellRendererLinkBride.vue?vue&type=template&id=2985a040&"
import script from "./CellRendererLinkBride.vue?vue&type=script&lang=js&"
export * from "./CellRendererLinkBride.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports